import styled from 'styled-components'

export const LayoutWrapper = styled.div`
  position: relative;
  height: 100%;
`

export const PageWrapper = styled.div`
  position: relative;
`

export const ContentWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
  .page {
    top: 0;
    transition: opacity 0.25s;
    height: 100%;
    width: 100%;
  }
  .page.entering,
  .page.entered {
    position: relative;
    opacity: 1;
  }
  .page.exiting,
  .page.exited {
    position: absolute;
    opacity: 0;
  }
`

export const HideBlock = styled.div`
  display: ${({ hide }) => hide && 'none'};
`
export const MobileBrocureLink = styled.div`
  position: fixed;
  z-index: 2;
  right: -42px;
  top: 50vh;
  transform: rotate(-90deg) translateY(100%);
`
